import { createCarousel } from "../carousel/utils/createCarousel";
import { createCta } from "./html-elements/cta";
import { callApi } from "./utils/callApi";
import { getOptions } from "./utils/getOptions";

export const ProductContainer = async (element) => {
  const options = getOptions(element);
  const products = await callApi(options);
  const headline = options.headline 
    ? `<h2 class="title" style="color: ${options.headlineColour}">${options.headline}</h2>` : "";
  const description = options.description 
    ? `<p class="subtitle" style="color: ${options.descriptionColour}">${options.description}</p>` : "";
  const cta = options.ctaText ? createCta(options, products) : "";
  const header = headline || description || cta ? `<div class="carousel-header-container">
      <div class="carousel-title">
        ${headline}
        ${description}
      </div>
      ${ cta ? cta : ""}
    </div>` : "";

  const carouselConfig = {
    type: options.type === "grid" ? "grid" : "carousel",
    root: options.type === "grid" ? "product-container-grid" : "carousel",
    rootAriaLabel: options.type === "grid" ? `Product grid` : "Carousel",
    headline: header,
    next: {
      buttonColor: options.buttonColour,
    },
    prev: {
      buttonColor: options.buttonColour,
    },
    maxPageSize: 4,
    previewNextPagePercentage: 0.25,
    hideDots: options.type === "grid",
    mobilePageSize: 2,
  };
  element.innerHTML = createCarousel(products, carouselConfig);
  element.classList.add("no-spin");
};
